import type { UserAuthPaths } from '../types'
import { loginErrorClass, useMutation, useUserAuthClient } from '#imports'

type MagicLinkGenerateBody = NonNullable<UserAuthPaths['/v1/public/magic-link/generate']['post']['requestBody']>['content']['application/json']
type MagicLinkLoginBody = NonNullable<UserAuthPaths['/v1/public/magic-link/login']['post']['requestBody']>['content']['application/json']
type MagicLinkLoginResponse = UserAuthPaths['/v1/public/magic-link/login']['post']['responses']['200']['content']['application/json']

export const useMagicLink = () => {
    const { client } = useUserAuthClient()

    const generateMutation = useMutation(async (payload: MagicLinkGenerateBody) => {
        const { data } = await client.POST('/v1/public/magic-link/generate', {
            body: payload
        })

        return data
    })

    const loginMutation = useMutation(async (payload: MagicLinkLoginBody) => {
        const { data } = await client.POST('/v1/public/magic-link/login', {
            body: payload
        })

        return data as MagicLinkLoginResponse
    }, {
        errorClass: loginErrorClass,
    })

    return {
        generate: generateMutation,
        login: loginMutation
    }
}
